import { render, staticRenderFns } from "./StoriesMoreSpacer.vue?vue&type=template&id=2e30736c&scoped=true&"
import script from "./StoriesMoreSpacer.vue?vue&type=script&lang=js&"
export * from "./StoriesMoreSpacer.vue?vue&type=script&lang=js&"
import style0 from "./StoriesMoreSpacer.vue?vue&type=style&index=0&id=2e30736c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e30736c",
  null
  
)

export default component.exports